'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormatPickerToken = require('./components/FormatPickerToken.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormatPickerToken).default;
  }
});

var _Pill = require('./components/Pill.component');

Object.defineProperty(exports, 'Pill', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Pill).default;
  }
});

var _AdditionalItemFormatsPopup = require('./components/AdditionalItemFormatsPopup.component');

Object.defineProperty(exports, 'AdditionalItemFormatsPopup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AdditionalItemFormatsPopup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/format-picker-token/lib/index.js
// module id = 1180
// module chunks = 9